import { create } from "zustand";

// Globalny modal informujący o braku przestrzeni dyskowej (np. przy inicjacji uploadu,
// gdy BE zwróci błąd DiskQuotaExceeded). Otwierany z interceptora axios.
interface DiskSpaceModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useDiskSpaceModalStore = create<DiskSpaceModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
